import DOMPurify from "dompurify";

export const sanitize = (dirty: string | undefined) => {
  const clean = dirty ? DOMPurify.sanitize(dirty) : "";
  return clean;
};
